import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import TextAreaInput from "../../common/TextAreaInput";
import Section from "../../common/Section";
import Form from "../../common/Form";
import RadioButtonText from "../../common/RadioButtonText";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import DateInput from "../../common/DateInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

const VRProjectForm = (props) => {
	const {
		vrProject,
		disabled,
		errors,
		onChange,
		onSave,
		color,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	return (
		<Section title="Vul het inhoudelijk voortgangsrapport in" color={color} disabled={disabled}>
			<Form
				title="Invulformulier project"
				name="project"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>

				<Fieldset title="Jouw gegevens">
					<TextInput
						label="Naam (max 100 tekens)"
						name="indienerNaam"
						value={vrProject.indienerNaam}
						onChange={onChange}
						size={6}
						validationMessage={errors ? errors.indienerNaam : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/>
					<TextInput
						label="Functie (max 100 tekens)"
						name="indienerFunctie"
						value={vrProject.indienerFunctie}
						onChange={onChange}
						size={6}
						validationMessage={errors ? errors.indienerFunctie : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/>
					<TextInput
						label="E-mail adres (max 100 tekens)"
						name="indienerEmail"
						value={vrProject.indienerEmail}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.indienerEmail : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/>
				</Fieldset>
				<Fieldset title="Zijn er wijzigingen m.b.t. de omschrijving van het project t.o.v. het goedgekeurde dossier ?">
					<RadioButtonText
						label=""
						name="isOmschrijvingProjectGewijzigd"
						value={vrProject.isOmschrijvingProjectGewijzigd}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.isOmschrijvingProjectGewijzigd : ''}
						validationMessageType={validationMessageType}
						nameJa="toelichtingWijzigingOmschrijvingProject"
						valueJa={vrProject.toelichtingWijzigingOmschrijvingProject}
						labelJa="Licht toe bij wijzigingen. (max 1500 tekens)"
						errorJa={errors ? errors.toelichtingWijzigingOmschrijvingProject : ''}
					/>
				</Fieldset>
				<Fieldset title="In welke fase bevindt het project zich ?">
					<TextAreaInput
						label="Toelichting (max 1500 tekens)"
						name="toelichtingFaseProject"
						value={vrProject.toelichtingFaseProject}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.toelichtingFaseProject : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						height={4}
					/>
				</Fieldset>
				<Fieldset
					title="Voorlopige opleveringsdatum van het hele project"
					tooltip="Voorlopige opleveringsdatum van de infrastructuur die het laatst opgeleverd wordt."
					tooltipWindowWidth={35}>
					<div className="o-col-6">
						<FieldsetSubHeader>Vooropgestelde voorlopige opleveringsdatum</FieldsetSubHeader>
					</div>
					<div className="o-col-6">
						<FieldsetSubHeader>Initiële voorlopige opleveringsdatum</FieldsetSubHeader>
					</div>
					<DateInput
						label=""
						name="vooropgesteldeOpleveringsdatum"
						value={vrProject.vooropgesteldeOpleveringsdatum}
						size={6}
						disabled={disabled || !vrProject.initieleOpleveringsdatum}
						onChange={onChange}
						validationMessage={errors ? errors.vooropgesteldeOpleveringsdatum : ''}
						validationMessageType={validationMessageType} />
					<DateInput
						label=""
						name="initieleOpleveringsdatum"
						value={vrProject.initieleOpleveringsdatum}
						size={6}
						disabled
						readOnly
						onChange={onChange}
						validationMessage={errors ? errors.initieleOpleveringsdatum : ''}
						validationMessageType={validationMessageType} />
					{vrProject.vooropgesteldeOpleveringsdatum && vrProject.initieleOpleveringsdatum && (vrProject.vooropgesteldeOpleveringsdatum.substring(0, 10) !== vrProject.initieleOpleveringsdatum.substring(0, 10)) ?
						<div>
							<FieldsetSubHeader>Licht toe indien de voorlopige opleveringsdatum afwijkt t.o.v. het ingediende dossier.</FieldsetSubHeader>
							<TextAreaInput
								label="Toelichting (max 1500 tekens)"
								name="toelichtingAfwijkendeDatumOplevering"
								value={vrProject.toelichtingAfwijkendeDatumOplevering}
								onChange={onChange}
								size={12}
								validationMessage={errors ? errors.toelichtingAfwijkendeDatumOplevering : ''}
								validationMessageType={validationMessageType}
								disabled={disabled}
								height={4}
							/>
						</div> : null}
				</Fieldset>
				<Fieldset
					title="Openingsdatum van het hele project"
					tooltip="Openingsdatum van de infrastructuur die het laatst geopend wordt."
					tooltipWindowWidth={35}>
					<div className="o-col-6">
						<FieldsetSubHeader>Vooropgestelde openingsdatum</FieldsetSubHeader>
					</div>
					<div className="o-col-6">
						<FieldsetSubHeader>Initiële openingsdatum</FieldsetSubHeader>
					</div>
					<DateInput
						label=""
						name="vooropgesteldeOpeningsdatum"
						value={vrProject.vooropgesteldeOpeningsdatum}
						size={6}
						disabled={disabled || !vrProject.initieleOpeningsdatum}
						onChange={onChange}
						validationMessage={errors ? errors.vooropgesteldeOpeningsdatum : ''}
						validationMessageType={validationMessageType} />
					<DateInput
						label=""
						name="initieleOpeningsdatum"
						value={vrProject.initieleOpeningsdatum}
						size={6}
						disabled
						readOnly
						onChange={onChange}
						validationMessage={errors ? errors.initieleOpeningsdatum : ''}
						validationMessageType={validationMessageType} />
					{vrProject.vooropgesteldeOpeningsdatum && vrProject.initieleOpeningsdatum && (vrProject.vooropgesteldeOpeningsdatum.substring(0, 10) !== vrProject.initieleOpeningsdatum.substring(0, 10)) ?
						<div>
							<FieldsetSubHeader>Licht toe indien de openingsdatum afwijkt t.o.v. het ingediende dossier.</FieldsetSubHeader>
							<TextAreaInput
								label="Toelichting (max 1500 tekens)"
								name="toelichtingAfwijkendeDatumOpening"
								value={vrProject.toelichtingAfwijkendeDatumOpening}
								onChange={onChange}
								size={12}
								validationMessage={errors ? errors.toelichtingAfwijkendeDatumOpening : ''}
								validationMessageType={validationMessageType}
								disabled={disabled}
								height={4}
							/>
						</div>
						: null}
				</Fieldset>
				<Fieldset
					title="Is dit het eindrapport waarmee je de éénmalige uitbetaling van de subsidie aanvraagt ?"
					tooltip="Subsidies kunnen pas worden uitbetaald na de voorlopige oplevering van het HELE project."
					tooltipWindowWidth={35}>
					<RadioButtonGroup
						name="isEindrapport"
						value={vrProject.isEindrapport}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.isEindrapport : ''}
						validationMessageType={validationMessageType}
					/>
				</Fieldset>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
VRProjectForm.propTypes = {
	vrProject: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	validationMessageType: PropTypes.string
};

export default VRProjectForm;
